// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--4rEPB";
export var childBlock = "styles-module--childBlock--U6yCR";
export var children = "styles-module--children--wsy9G";
export var contentBlock = "styles-module--contentBlock--mS7m2";
export var figure = "styles-module--figure--0cXtg";
export var gridThreeColumns = "styles-module--gridThreeColumns--CWQ2O";
export var gridTwoColumns = "styles-module--gridTwoColumns--lvQwJ";
export var m_flexible_module = "styles-module--m_flexible_module--PXQwH";
export var textBlock = "styles-module--textBlock--Ay1tc";